import React from "react"

import PopoverMenuItem from "../../../gd-components/popover-menu/popover-menu/menu-item"
import PopoverMenuSeparator from "../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import ApiDocument from "../../../gd/api/document"
import Request from "../../../gd/data/request"
import PinsApi from "../../../gd/api/pins-api"
import PrintVersionDocumentView from "../../../../item-view/doc/print-version/print-version";
import DocumentExportContainer from "../../../../item-view/doc/pdf-version/pdf-version";
import {ITEM_VIEW_DOCUMENT, ItemViewType} from "../../../gd/app-manager/item-view";
import {DocumentMoreConfig} from "./more-button";
import {DocumentSystemType} from "../../../model2/doc/types";
import exportToPdf from "../../../gd-app/import-export/export-to-pdf";

const debug: boolean = false
// const debug: string = "DocumentMoreMenu"

type Props = {
    model           : any
    revisionId?     : ID
    config          : DocumentMoreConfig
    hidePopover     : callback
}

export default function DocumentMoreMenu(props: Props) {

    const document                      = props.model
    const revisionId                    = props.revisionId
    const config: DocumentMoreConfig    = props.config

    const onRename = ():void => {
        props.hidePopover()

        gd.modals.document.rename(document)
    }

    const onOpenNewWindow = ():void => {
        gd.openInNewWindow("/n/"+document.id)
        props.hidePopover()
    }

    const onUnpin = ():void => {
        const pinId = gd.session.pins.getPinId({documentId:document.id})
        if (!pinId) return
        gd.session.pins.remove(pinId)
        PinsApi.removePin(pinId)

        props.hidePopover()
    }

    const onPin = ():void => {
        PinsApi.addPin({documentId:document.id})

        props.hidePopover()
    }

    const onMove = ():void => {
        const projectUsers: string[] = []
        gd.session.projectUsers.filterByProject(document.projectId).map((pu:any)=>{
            projectUsers.push(pu.user.id)
        })

        gd.modals.document.move(document)

        props.hidePopover()
    }

    const onSaveAsTemplate = ():void => {
        props.hidePopover()
        gd.modals.document.saveAsTemplate(document)
    }

    const onDuplicate = ():void => {
        props.hidePopover()
        gd.modals.document.duplicate(document)
    }

    const onChangeType = ():void => {
        props.hidePopover()
        gd.modals.document.convertType(document)
    }

    const onExportToPDF = ():void => {
        debug && console.log(debug, 'onExportToPDF')

        const documentView = gd.itemView.findByContainerId(ItemViewType.ITEM_VIEW_DOCUMENT)
        const app = documentView?.app
        if (app) {
            const isPro = gd.session.companies.get(gd.companyId).license.isPro
            isPro ?
                exportToPdf(app, {
                    exportComponent: <DocumentExportContainer document      = {document}
                                                              revisionId    = {revisionId}/>
                })
                :
                gd.modals.other.upgradeToPro(gd.companyId)
        }

        props.hidePopover()
    }

    const onPrint = ():void => {
        debug && console.log(debug, 'onPrint')

        new PrintVersionDocumentView(document, revisionId).print()

        props.hidePopover()
    }

    const onDelete = ():void => {
        if (document.canBeDeleted) {

            let confirmMessage = ""

            switch (document.systemType) {
                case DocumentSystemType.WHITEBOARD: {
                    confirmMessage = "Are you sure that you want to delete this whiteboard?"
                    break
                }
                case DocumentSystemType.DEFAULT:
                default:
                    confirmMessage = "Are you sure that you want to delete this note?"
            }

            gd.modals.confirm.deleteTextMessage(document.name, confirmMessage,()=>{
                const request:Request = ApiDocument.delete(document.id)
                request.done(()=>{
                    gd.modal.hide()
                })
            });

        } else {

            let warningMessage = ""

            switch (document.systemType) {
                case DocumentSystemType.WHITEBOARD_RESOURCE:
                    warningMessage = "This is the Whiteboard View document. It can only be deleted by removing the Whiteboard View."
                    break
                case DocumentSystemType.PAGE:
                default:
                    warningMessage = "This is the Page View document. It can only be deleted by removing the Page View."
            }

            gd.modals.other.notification(<div className="flex-row-center-center p-h-20">{warningMessage}</div>)
        }

        props.hidePopover()
    }

    const isPagePinned = !!gd.session.pins.getPinId({documentId:document.id})

    return (


        <div className="ui5-popover-menu">

            {config.openNewWindow!==false &&
                <PopoverMenuItem icon="i5-open-new-window"
                                 label="Open in a new window"
                                 onClick={onOpenNewWindow}
                                 disabled={config.openNewWindow==='disabled'}
                />
            }

            {config.pin &&
                <React.Fragment>
                    {isPagePinned &&
                        <PopoverMenuItem icon="i5-pin-full"
                                         label="Unpin from home menu"
                                         onClick={onUnpin}
                                         disabled={config.pin==='disabled'}/>
                    }
                    {!isPagePinned  &&
                        <PopoverMenuItem icon="i5-pin"
                                         label="Pin to home menu"
                                         onClick={onPin}
                                         disabled={config.pin==='disabled'}
                        />
                    }
                </React.Fragment>
            }

            {(config.openNewWindow || config.pin) &&
                <PopoverMenuSeparator />
            }

            {config.rename !== false &&
                <PopoverMenuItem icon       = " i5-pen"
                                 label      = "Rename"
                                 disabled   = {config.rename === 'disabled'}
                                 onClick    = {onRename}/>}

            {config.move &&
                <PopoverMenuItem icon="i5-move"
                                 label="Move to"
                                 onClick={onMove}
                                 disabled={config.move==='disabled'}/>
            }

            {config.convert &&
                <PopoverMenuItem icon="i5-task-types"
                                 label="Change Document Type"
                                 onClick={onChangeType}
                                 disabled={config.convert==='disabled'}/>
            }

            {(config.duplicate || config.saveAsTemplate) &&
                <PopoverMenuSeparator />
            }

            {config.duplicate &&
                <PopoverMenuItem icon="i5-clone"
                                 label="Duplicate"
                                 onClick={onDuplicate}
                                 disabled={config.duplicate==='disabled'}/>
            }

            {config.saveAsTemplate &&
                <PopoverMenuItem icon="i5-layers"
                                 label="Save As Template"
                                 onClick={onSaveAsTemplate}
                                 disabled={config.saveAsTemplate==='disabled'}/>
            }




            {config.export &&
                <React.Fragment>
                    <PopoverMenuSeparator />
                    <PopoverMenuItem icon="i5-pdf"       label="Export to PDF"           onClick={onExportToPDF}/>
                    <PopoverMenuItem icon="i5-print"           label="Print"                   onClick={onPrint}/>


                </React.Fragment>}


            {config.delete &&
                <React.Fragment>
                    <PopoverMenuSeparator />
                    <PopoverMenuItem icon="i5-trash-alt"
                                     label="Delete"
                                     onClick={onDelete}
                                     disabled={config.delete==='disabled'}/>
                </React.Fragment>
            }


        </div>
    )
}
